<template>
  <div>
    <Loading :value="loading"></Loading>
    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
          >{{ item.text }}</v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <v-layout row v-if="user.type == 1" class="text-xs-center">
      <v-flex md6>
        <div id="demandeGblobal" style="width: auto; height: 400px"></div>
      </v-flex>

      <v-flex md6>
        <div id="statusGbDemande" style="width:auto; height: 400px"></div>
      </v-flex>
    </v-layout>

    <v-layout row v-else class="text-xs-center">
      <v-flex md6 v-show="user.type == 1">
        <div id="demandeGblobal" style="width: auto; height: 400px"></div>
      </v-flex>
      <v-flex md12 class="text-xs-center">
        <div id="statusGbDemande" style="width: auto; height: 400px"></div>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex md3 mr-4>
        <v-card>
          <v-toolbar color="cyan" dark>
            <v-toolbar-title>Informations</v-toolbar-title>
          </v-toolbar>

          <v-list subheader two-line>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Noms et prénom(s)</v-list-tile-title>
                <v-list-tile-sub-title>{{infoRepresentant.nomRepresentant}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Fonction ou Profession</v-list-tile-title>
                <v-list-tile-sub-title>{{infoRepresentant.profession}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>
            
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Zone(s) Concernée(s)</v-list-tile-title>
                <v-tooltip top>
                  <v-btn
                    v-if="user.type == 1 && droitAcces.zone_create"
                    slot="activator"
                    icons
                    color="primary"
                    @click.stop="modalAjoutZone()"
                    dark
                  >
                    Ajouter une nouvelle zone
                    <v-icon right>playlist_add</v-icon>
                  </v-btn>Ajouter une nouvelle zone
                </v-tooltip>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <div>
            <el-tree
              :data="zones"
              class="filter-tree"
              default-expand-all
              :filter-node-method="filterNode"
              node-key="id"
              :props="defaultProps"
              ref="tree"
              @dblclick.native="handleNodeClick"
            ></el-tree>
          </div>
        </v-card>
      </v-flex>

      <!--Listes des missions-->
      <v-flex md9>
        <v-container>
          <v-layout row>
            <v-card style="width:100%">
              <v-card-text fluid grid-list-md>
                <h6>{{legendeTab}}</h6>
                <v-divider></v-divider>
                <v-layout row v-if="user.type == 1">
                  <v-flex class="mb-1" xs12 md10>
                    <v-card-text class="text-xs-center">
                      <v-chip
                        label
                        outline
                        color="orange darken-1"
                        class="elevation-4"
                        style="width:100%"
                      >
                        <span class="subheading">Bilan financier des interventions effectuées:</span>
                        <span class="title">{{mntTTC}} Fcfa</span>
                      </v-chip>
                    </v-card-text>
                  </v-flex>
                </v-layout>

                <v-layout row class="mb-2">
                  <v-flex xs4>
                    <v-chip color="cyan" text-color="white">
                      <v-avatar class="cyan darken-4">{{totalDmd}}</v-avatar>Demandes
                    </v-chip>
                  </v-flex>

                  <v-flex xs4>
                    <v-chip color="cyan" text-color="white">
                      <v-avatar class="cyan darken-4">{{totalDmdCour}}</v-avatar>Demandes en cours
                    </v-chip>
                  </v-flex>

                  <v-flex xs4>
                    <v-chip color="cyan" text-color="white">
                      <v-avatar class="cyan darken-4">{{totalDmdRetard}}</v-avatar>Demandes en retard
                    </v-chip>
                  </v-flex>
                </v-layout>

                <v-layout row class="mb-3 mt-1">
                  <v-flex md3 class="mr-1" v-if="user.type != 2">
                    <el-select
                      clearable
                      @clear="clearSelect()"
                      @change="filtrerEtatDmd"
                      v-model="selectEtatDmd"
                      placeholder="Filtrer par etat"
                    >
                      <el-option
                        v-for="item in comboEtatDmd"
                        :key="item.etat"
                        :label="item.label"
                        :value="item.etat"
                      ></el-option>
                    </el-select>
                  </v-flex>

                  <v-flex md3>
                    <el-select
                      clearable
                      @clear="clearSelect()"
                      @change="filtrerStatusDmd"
                      v-model="selectStatusDmd"
                      placeholder="Filtrer par status"
                    >
                      <el-option
                        v-for="item in comboStatusDmd"
                        :key="item.etat"
                        :label="item.label"
                        :value="item.etat"
                      ></el-option>
                    </el-select>
                  </v-flex>

                  <v-flex md3>
                    <el-select
                      clearable
                      @clear="clearSelect()"
                      @change="filtrerRetardDmd"
                      v-model="selectRetardDmd"
                      placeholder="Demande en retard"
                    >
                      <el-option
                        v-for="item in comboRetardDmd"
                        :key="item.etat"
                        :label="item.label"
                        :value="item.etat"
                      ></el-option>
                    </el-select>
                  </v-flex>

                  <v-flex md4>
                    <el-select
                      clearable
                      @clear="clearSelect()"
                      filterable
                      @change="filtrerZoneDmd"
                      v-model="selectZoneDmd"
                      placeholder="Demande par zone"
                    >
                      <el-option
                        v-for="item in comboZoneDmd"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </v-flex>
                </v-layout>

                <!-- BTN AJOUT -->
                <v-spacer></v-spacer>
                <div class="text-xs-right">
                  <v-tooltip top>
                    <v-btn
                      v-if="droitAcces.new_maintenance"
                      slot="activator"
                      icons
                      color="primary"
                      @click.stop="modalAjoutDmd()"
                      dark
                    >
                      Ajouter une demande
                      <v-icon right>playlist_add</v-icon>
                    </v-btn>Ajouter une nouvelle demande
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn
                      v-if="droitAcces.imprimer_liste_demande"
                      slot="activator"
                      color="orange"
                      :disabled="disabledBtnMiss"
                      @click.stop="imprimeDemandePDF()"
                      dark
                    >
                      Imprimer
                      <v-icon right>print</v-icon>
                    </v-btn>Imprimer la liste des demandes
                  </v-tooltip>
                </div>

                <data-tables :data="listeDemandes">
                  <el-table-column prop="date" label="Date"></el-table-column>
                  <el-table-column prop="nomDemandeur" label="Nom du demandeur"></el-table-column>
                  <el-table-column prop="libStatut" label="Statut">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.statut == 0" type="info">{{scope.row.libStatut}}</el-tag>
                      <el-tag v-if="scope.row.statut == 1">{{scope.row.libStatut}}</el-tag>
                      <el-tag v-if="scope.row.statut == 2" type="success">{{scope.row.libStatut}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="batiment" label="Batiment"></el-table-column>
                  <el-table-column prop="salle" label="Salle"></el-table-column>
                  <el-table-column prop="libPriorite" label="Priorite">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.etat == 3" type="info">{{scope.row.libPriorite}}</el-tag>
                      <el-tag v-if="scope.row.priorite == 0" type="info">{{scope.row.libPriorite}}</el-tag>
                      <el-tag v-if="scope.row.priorite == 1">{{scope.row.libPriorite}}</el-tag>
                      <el-tag
                        v-if="scope.row.priorite == 2"
                        type="warning"
                      >{{scope.row.libPriorite}}</el-tag>
                      <el-tag v-if="scope.row.priorite == 3" type="danger">{{scope.row.libPriorite}}</el-tag>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column v-if="user.type == 1" prop="mntFacture" label="MontantTTC (Fcfa)" > </el-table-column> -->
                  <el-table-column label="Action" align="center" fixed="right">
                    <template slot-scope="scope">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click="modalDetailDmd(scope.row)"
                          fab
                          dark
                          small
                          color="blue"
                        >
                          <v-icon dark>list</v-icon>
                        </v-btn>Detail de la demande
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn
                          v-if="scope.row.etatDmd == 1 && droitAcces.edit_maintenance"
                          slot="activator"
                          @click="modalEditDmd(scope.row)"
                          fab
                          dark
                          small
                          color="orange"
                        >
                          <v-icon dark>edit</v-icon>
                        </v-btn>Editer
                      </v-tooltip>

                      <!-- <v-tooltip top>
                  <v-btn v-if="droitAcces.attribuer_technicien_maintenance && scope.row.etatDmd == 1" slot="activator" @click="modalTechnicien(scope.row)" fab dark small color="orange">
                    <v-icon dark>account_circle</v-icon>
                      </v-btn>
                        Designer un technicien
                      </v-tooltip>-->

                      <v-tooltip top>
                        <v-btn
                          v-if="droitAcces.save_constat && scope.row.etatDmd == 2"
                          slot="activator"
                          @click="modalConstat(scope.row)"
                          fab
                          dark
                          small
                          color="teal"
                        >
                          <v-icon dark>build</v-icon>
                        </v-btn>Effectuer le constat
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn
                          v-if="(droitAcces.validation_devis && scope.row.etatDmd == 3)  "
                          slot="activator"
                          @click="modalValidConstat(scope.row)"
                          fab
                          dark
                          small
                          color="green"
                        >
                          <v-icon dark>done_all</v-icon>
                        </v-btn>Valider le devis du constat
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn
                          v-if="droitAcces.attribuer_technicien_maintenance && scope.row.etatDmd == 5"
                          slot="activator"
                          @click="modalplanification(scope.row)"
                          fab
                          dark
                          small
                          color="yellow"
                        >
                          <v-icon dark>list</v-icon>
                        </v-btn>Planifier l'intervention
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn
                          v-if="droitAcces.save_constat && scope.row.etatDmd == 7"
                          slot="activator"
                          @click="modalRapportDepannage(scope.row)"
                          fab
                          dark
                          small
                          color="brown"
                        >
                          <v-icon dark>list</v-icon>
                        </v-btn>Rapport de depannage
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn
                          v-if="droitAcces.new_maintenance && droitAcces.avis_demande_representant && scope.row.etatDmd == 8"
                          slot="activator"
                          @click="modalRapportSatisfaction(scope.row)"
                          fab
                          dark
                          small
                          color="blue-grey"
                        >
                          <v-icon dark>list</v-icon>
                        </v-btn>Donnez votre avis
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn
                          v-if="scope.row.etatDmd == 1 && droitAcces.delete_demande_maintenance"
                          slot="activator"
                          @click.stop="itemDmd = scope.row;dialogSupr = true; "
                          fab
                          dark
                          small
                          color="red"
                        >
                          <v-icon dark>delete</v-icon>
                        </v-btn>Supprimer
                      </v-tooltip>
                    </template>
                  </el-table-column>
                </data-tables>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-container>
      </v-flex>

      <!-- MODAL SUPPRESSION DEMANDE -->
      <v-dialog v-model="dialogSupr" persistent max-width="50%">
        <v-card>
          <v-card-title class="headline">Supprimer cet enregistrement ?</v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 class="mb-2">
                <el-alert
                  title="La suppression est définitive"
                  :closable="false"
                  show-icon
                  type="error"
                ></el-alert>
              </v-flex>
              <v-flex xs12>
                <p class="grey--text font-weight-thin body-1">DEMANDE</p>
                <p class="black--text .font-weight-regular subheading">DMD-{{itemDmd.idDemande}}</p>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" dark @click="dialogSupr = false">
              Annuler
              <v-icon right>remove_circle</v-icon>
            </v-btn>
            <v-btn color="red darken-1" dark @click="deleteDmd()">
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- MODAL SUPPRESSION DEMANDE -->
    </v-layout>

    <!-- MODAL SUPPRESSION ZONE -->
    <v-dialog v-model="dialogSuppZone" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Supprimer cet enregistrement ?</v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="mb-2">
              <el-alert
                title="La suppression est définitive"
                description="Veuillez vous assurer qu'aucune demande n'a été effectuée dans cette zone"
                :closable="false"
                show-icon
                type="error"
              ></el-alert>
            </v-flex>
            <v-flex xs12>
              <p class="grey--text font-weight-thin body-1">ZONE</p>
              <p class="black--text .font-weight-regular subheading">{{dataZone.label}}</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark @click="dialogSuppZone = false">
            Annuler
            <v-icon right>remove_circle</v-icon>
          </v-btn>
          <v-btn color="red darken-1" dark @click="deleteZone()">
            Supprimer
            <v-icon right>delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- MODAL SUPPRESSION ZONE -->

    <!-- MODAL OPTION DES ZONES -->
    <v-bottom-sheet v-model="dialogZoneEdit">
      <v-list>
        <v-subheader>{{dataZone.label}}/ Responsable de zone {{dataZone.responsable}} / Representant de zone {{dataZone.representant}}</v-subheader>
        <v-list-tile v-if="droitAcces.zone_add" @click="modalAjoutSousZone(dataZone)">
          <v-list-tile-avatar>
            <v-avatar size="32px" tile>
              <v-btn icon>
                <v-icon>add</v-icon>
              </v-btn>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title @click="modalAjoutSousZone(dataZone)">Ajouter une sous zone</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="droitAcces.zone_add" @click="modalEditZone(dataZone)">
          <v-list-tile-avatar>
            <v-avatar size="32px" tile>
              <v-btn icon>
                <v-icon>mode_edit</v-icon>
              </v-btn>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title @click="editZone(dataZone)">Modifier</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="droitAcces.zone_file_remove" @click="modalDeleteZone(dataZone)">
          <v-list-tile-avatar>
            <v-avatar size="32px" tile>
              <v-btn icon>
                <v-icon>delete_forever</v-icon>
              </v-btn>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title @click="modalDeleteZone(dataZone);">Supprimer</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>

    <!-- MODAL planification -->
    <v-dialog
      v-model="dialogPlanification"
      max-width="600"
      :persistent="true"
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Planifier une intervention pour la demande DMD-{{demandeDetail.idDemande}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialogPlanification = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <el-form
            id="formPlanning"
            label-width="90px"
            :model="formPlanning"
            :rules="rulesformPlanning"
            ref="formPlanning"
            class="demo-form-inline"
          >
            <el-form-item label="Techniciens" required>
              <el-col :span="22">
                <el-form-item prop="technicien">
                  <el-select
                    filterable
                    v-model="formPlanning.selectTech"
                    name="technicien"
                    placeholder="Selectionner un technicien"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in listeTechniciens"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="Debut" required>
              <el-col :span="11">
                <el-form-item prop="dateDbt">
                  <el-date-picker
                    type="date"
                    placeholder="Choisir une date de debut"
                    format="dd-MM-yyyy"
                    v-model="formPlanning.dateDbt"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="hrDbt">
                  <el-time-picker
                    type="fixed-time"
                    placeholder="Choisir une heure de debut"
                    v-model="formPlanning.hrDbt"
                    style="width: 100%;"
                  ></el-time-picker>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="Fin" required>
              <el-col :span="11">
                <el-form-item prop="dateFin">
                  <el-date-picker
                    type="date"
                    placeholder="Choisir une date de fin"
                    format="dd-MM-yyyy"
                    v-model="formPlanning.dateFin"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="hrFin">
                  <el-time-picker
                    type="fixed-time"
                    placeholder="Choisir une heure de fin"
                    v-model="formPlanning.hrFin"
                    style="width: 100%;"
                  ></el-time-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item class="text-xs-right">
              <v-btn color="grey" @click="resetForm('formPlanning')" dark>
                Annuler
                <v-icon right>remove_circle</v-icon>
              </v-btn>
              <v-btn icons dark color="green" @click="submitFormPlanning('formPlanning')">
                Enregistrer
                <v-icon right>add</v-icon>
              </v-btn>
            </el-form-item>
          </el-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <!-- MODAL planification -->

    <!-- AJOUTER UNE DEMANDE DE MAINTENANCE -->
    <AjoutMaintenance
      :editForm="editFormDmd"
      :demandeDetail="demandeDetail"
      :show="showModalAjoutDmd"
      @close="showModalAjoutDmd = false;loadDemande()"
    ></AjoutMaintenance>
    <!-- AJOUTER UNE DEMANDE DE MAINTENANCE -->

    <!-- Detail de la demande de maintenance -->
    <DetailMaintenance
      :demandeDetail="demandeDetail"
      :show="showModalDetailDmd"
      @close="showModalDetailDmd = false"
    ></DetailMaintenance>
    <!-- Detail de la demande de maintenance -->

    <!-- Selection d'un technicien -->
    <SelectionTechnicien
      :listeTechniciens="listeTechniciens"
      :demandeDetail="demandeDetail"
      :show="showModalSelectTechnicien"
      @close="showModalSelectTechnicien = false;loadDemande()"
    ></SelectionTechnicien>
    <!-- Selection d'un technicien -->

    <!-- Constat -->
    <ConstatMaintenance
      :validConstat="validConstat"
      :demandeDetail="demandeDetail"
      :show="showModalConstat"
      @close="showModalConstat = false, validConstat= false;loadDemande() "
    ></ConstatMaintenance>
    <!-- Constat -->

    <!-- Rapport de depannage -->
    <RapportDepannage
      :demandeDetail="demandeDetail"
      :show="showModalRapportDepannage"
      @close="showModalRapportDepannage = false;loadDemande()"
    ></RapportDepannage>
    <!-- Rapport de depannage -->

    <!-- Rapport de depannage -->
    <RapportSatisfaction
      :demandeDetail="demandeDetail"
      :show="showModalRapportSatisfaction"
      @close="showModalRapportSatisfaction = false;loadDemande()"
    ></RapportSatisfaction>
    <!-- Rapport de depannage -->

    <!-- Ajout zone maintenance -->
    <AjoutZoneMaintenance
      :editForm="editFormZone"
      :zoneDetail="zoneDetail"
      :show="showModalAjoutZone"
      @close="showModalAjoutZone = false;loadInfoRepresentant();dialogZoneEdit = false"
    ></AjoutZoneMaintenance>
    <!-- Ajout zone maintenance -->
  </div>
</template>

<script>
//function de difference de date

function dateDiff(date1, date2) {
  var diff = {}; // Initialisation du retour
  var tmp = date2 - date1;

  tmp = Math.floor(tmp / 1000); // Nombre de secondes entre les 2 dates
  diff.sec = tmp % 60; // Extraction du nombre de secondes

  tmp = Math.floor((tmp - diff.sec) / 60); // Nombre de minutes (partie entière)
  diff.min = tmp % 60; // Extraction du nombre de minutes

  tmp = Math.floor((tmp - diff.min) / 60); // Nombre d'heures (entières)
  diff.hour = tmp % 24; // Extraction du nombre d'heures

  tmp = Math.floor((tmp - diff.hour) / 24); // Nombre de jours restants
  diff.day = tmp;

  return diff;
}

var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import html2canvas from "html2canvas";

import AjoutMaintenance from "@/components/maintenance/AjoutMaintenance";
import DetailMaintenance from "@/components/maintenance/DetailMaintenance";
import SelectionTechnicien from "@/components/maintenance/SelectionTechnicien";
import ConstatMaintenance from "@/components/maintenance/ConstatMaintenance";
import RapportDepannage from "@/components/maintenance/RapportDepannage";
import RapportSatisfaction from "@/components/maintenance/RapportSatisfaction";
import AjoutZoneMaintenance from "@/components/maintenance/AjoutZoneMaintenance";
import Loading from "@/components/Loading";

export default {
  components: {
    Loading,
    AjoutMaintenance,
    DetailMaintenance,
    SelectionTechnicien,
    ConstatMaintenance,
    RapportDepannage,
    RapportSatisfaction,
    AjoutZoneMaintenance
  },
  name: "Maintenance_index",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [
        { path: "/maintenance", text: "Maintenance", disabled: false }
      ],
      showModalAjoutDmd: false,
      lieuSelect: "",
      dialogSupr: false,
      legendeTab: "LISTE DES DEMANDES DE MAINTENANCES",
      //detail demande
      showModalDetailDmd: false,
      showModalConstat: false,
      listeDemandes: [],
      zoneDetail: {},
      oldListDemandes: [],
      demandeDetail: {},
      dialogSupr: false,
      itemDmd: {},
      statDemandeG: null,
      statusDemande: null,
      dataZone: {},
      mntTTC: 0,
      disabledBtnMiss: false,
      selectZoneDmd: "",
      comboZoneDmd: [],
      editFormDmd: false,
      totalDmd: 0,
      totalDmdCour: 0,
      totalDmdRetard: 0,

      //infos representants
      infoRepresentant: {
        lieux: [],
        nomRepresentant: "",
        profession: ""
      },

      //Selection techniciens
      showModalSelectTechnicien: false,
      listeTechniciens: [],

      //valider constat
      validConstat: false,

      //rapport depannage
      showModalRapportDepannage: false,

      //rapport satisfaction
      showModalRapportSatisfaction: false,

      //Ajout zone
      showModalAjoutZone: false,

      //planning intervention
      dialogPlanification: false,
      formPlanning: {
        selectTech: ""
      },
      rulesformPlanning: {
        dateDbt: [
          {
            type: "date",
            required: true,
            message: "Choisir une date de debut",
            trigger: "change"
          }
        ],
        hrDbt: [
          {
            type: "date",
            required: true,
            message: "Choisir une heure de fin ",
            trigger: "change"
          }
        ],

        dateFin: [
          {
            type: "date",
            required: true,
            message: "Choisir une date de debut",
            trigger: "change"
          }
        ],
        hrFin: [
          {
            type: "date",
            required: true,
            message: "Choisir une heure de fin",
            trigger: "change"
          }
        ]
      },

      //filtre listed demandes
      selectEtatDmd: null,
      selectStatusDmd: null,
      selectRetardDmd: null,
      disabledBtnDmd: false,

      //select
      comboRetardDmd: [
        {
          etat: 0,
          label: "demande en retard de réalisation"
        }
      ],

      comboStatusDmd: [
        {
          etat: 0,
          label: "demande en attente de traitement"
        },
        {
          etat: 1,
          label: "demande en cours de traitement "
        },
        {
          etat: 2,
          label: "demande traitee"
        }
      ],
      comboEtatDmd: [
        {
          etat: 1,
          label: "En attente d'un technicien"
        },
        {
          etat: 2,
          label: "En attente d'un constat"
        },
        {
          etat: 3,
          label: "En attente de validation"
        },
        {
          etat: 5,
          label: "Demande Validée"
        },

        {
          etat: 6,
          label: "Demande refusée"
        },
        {
          etat: 7,
          label: "Intervention en cours"
        },
        {
          etat: 8,
          label: "Intervention terminée"
        },
        {
          etat: 9,
          label: "Demande cloturée"
        }
      ],
      //////////ZONE
      zones: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      editFormZone: false,
      dialogZoneEdit: false,
      dialogSuppZone: false
    };
  },
  computed: {},
  methods: {
    //attribuer zone
    modalAjoutDmd() {
      //this.demandeDetail = {}
      this.editFormDmd = false;
      this.showModalAjoutDmd = true;
    },
    modalEditDmd(itemDmd) {
      this.editFormDmd = true;
      this.demandeDetail = itemDmd;
      this.showModalAjoutDmd = true;
    },
    loadDemande() {
      let url =
        this.domaine + "demande_maintenance/liste_demande/" + this.user.id;
      this.$http.get(url).then(
        response => {
          this.mntTTC = response.body.mntTTC;
          this.listeDemandes = response.body.listeDemandes;
          this.oldListDemandes = response.body.listeDemandes;
          this.statDemandeG = response.body.pie;
          this.statusDemande = response.body.status;
          this.demandeAnnee = response.body.dataHist;

          //affichage nombre de demande
          this.totalDmd = this.listeDemandes.length;
          let totalDmdCour = this.listeDemandes.filter(function(element) {
            return element.statut == 1;
          });

          this.totalDmdCour = totalDmdCour.length;

          let totalDmdRetard = this.listeDemandes.filter(function(item) {
            let date1 = new Date(item.dateFormat);
            let dateNow = new Date();
            let diff = dateDiff(date1, dateNow);
            if (diff.day >= 1 && item.statut != 2) {
              //si la difference est superieur a 1jours la demande est en retard
              return true;
            } else {
              return false;
            }

            this.totalDmdRetard = totalDmdRetard.length;
          });

          this.statDemandeGlobal();
          this.statStatutDemande();
        },
        response => {}
      );
    },

    modalDetailDmd(item) {
      this.demandeDetail = item;
      this.showModalDetailDmd = true;
    },
    modalTechnicien(item) {
      //charger la liste des techniciens
      this.demandeDetail = item;
      this.loadTechnicien(item.idResponsableZone);
    },

    modalConstat(item) {
      this.demandeDetail = item;
      this.validConstat = false;
      this.showModalConstat = true;
    },

    modalValidConstat(item) {
      this.demandeDetail = item;
      this.validConstat = true;
      this.showModalConstat = true;
    },
    modalplanification(item) {
      this.demandeDetail = item;
      this.dialogPlanification = true;
    },

    modalRapportDepannage(item) {
      this.demandeDetail = item;
      this.showModalRapportDepannage = true;
    },
    modalRapportSatisfaction(item) {
      this.demandeDetail = item;
      this.showModalRapportSatisfaction = true;
    },

    modalAjoutZone() {
      this.zoneDetail = {};
      this.editFormZone = false;
      this.showModalAjoutZone = true;
    },
    modalAjoutSousZone(itemZone) {
      this.zoneDetail = itemZone;
      this.editFormZone = false;
      this.showModalAjoutZone = true;
    },

    modalEditZone(itemZone) {
      this.editFormZone = true;
      this.zoneDetail = itemZone;
      this.showModalAjoutZone = true;
    },

    modalDeleteZone(itemZone) {
      this.dialogSuppZone = true;
    },

    loadInfoRepresentant() {
      let url =
        this.domaine + "demande_maintenance/infoRepresentant/" + this.user.id;
      this.$http.get(url).then(
        response => {
          this.infoRepresentant = response.body.info;
          this.zones = this.infoRepresentant.lieux;
        },
        response => {
          this.$message.error(
            "Une erreur lors du chargement des donnees personnelles du representant"
          );
        }
      );
    },
    deleteDmd() {
      this.loading = true;

      let url =
        this.domaine + "demande_maintenance/delete/" + this.itemDmd.idDemande;
      this.$http.get(url).then(
        response => {
          this.loading = false;

          this.$notify({
            title: "SUPPRESSION",
            message: "Demande supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSupr = false;

          this.loadDemande();
        },
        errRep => {
          this.loading = false;
          this.dialogSupr = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression de la demande a échouée.",
            position: "top-center"
          });
        }
      );
    },

    deleteZone() {
      //this.loading = true
      let url = this.domaine + "demande_maintenance/delete/zone/maintenance";
      let data = new FormData();
      data.append("idZone", this.dataZone.id);

      this.$http.post(url, data).then(
        response => {
          this.loading = false;

          this.$notify({
            title: "SUPPRESSION",
            message: "Zone supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSuppZone = false;
          this.dialogZoneEdit = false;

          this.loadInfoRepresentant();
        },
        errRep => {
          this.$notify.error({
            title: "ECHEC DE SUPPRESSION",
            message: "La suppression de la zone a échouée",
            position: "top-center"
          });
        }
      );
    },
    loadTechnicien() {
      this.loading = true;
      let url = this.domaine + "demande_maintenance/technicien";
      this.$http.get(url).then(
        response => {
          this.loading = false;

          let codeMessage = response.body.code;
          let message = response.body.message;
          if (codeMessage == 1) {
            this.warningNotif(message);
          } else if (codeMessage == 2) {
            this.warningNotif(message);
          } else {
            this.listeTechniciens = response.body.technicien;
            this.showModalSelectTechnicien = false;
          }
        },
        errResp => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des techniciens"
          );
        }
      );
    },

    submitFormPlanning(formName) {
      if (this.formPlanning.selectTech == "") {
        this.$message.error("Veuillez selectionner un techinicien");
        return;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          let url = this.domaine + "demande_maintenance/planning/intervention";
          var data = new FormData();
          let dateDbt =
            this.formPlanning.dateDbt.getFullYear() +
            "-" +
            this.formPlanning.dateDbt.getMonth() +
            "-" +
            this.formPlanning.dateDbt.getDate();
          let hrDbt =
            this.formPlanning.hrDbt.getHours() +
            ":" +
            this.formPlanning.hrDbt.getMinutes();

          let dateFin =
            this.formPlanning.dateFin.getFullYear() +
            "-" +
            this.formPlanning.dateFin.getMonth() +
            "-" +
            this.formPlanning.dateFin.getDate();
          let hrFin =
            this.formPlanning.hrFin.getHours() +
            ":" +
            this.formPlanning.hrFin.getMinutes();

          data.append("dateDbt", dateDbt);
          data.append("hrDbt", hrDbt);
          data.append("dateFin", dateFin);
          data.append("hrFin", hrFin);
          data.append("idDemande", this.demandeDetail.idDemande);
          data.append("idUser", this.user.id);
          data.append("idTechnicien", this.formPlanning.selectTech);
          this.$http.post(url, data).then(
            response => {
              this.loading = false;
              //reinitialiser le formulaire
              this.resetForm("formPlanning");

              this.dialogPlanification = false;
              this.loadDemande();
              $messages = response.body.message;

              for (var ind in $messages) {
                this.successNotif($messages[ind]);
              }
            },
            erreur => {
              //reinitialiser le formulaire
              this.resetForm("formPlanning");

              this.loading = false;
              this.$message.error(
                "Une erreur est survenue lors de l'enregistrement de l'intervention'"
              );
            }
          );
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    successNotif(mess = "") {
      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },

    warningNotif(mess = "") {
      this.$notify({
        title: "Avertissement",
        message: mess,
        type: "warning",
        position: "top-center"
      });
    },
    //fonction de filtre
    filtrerEtatDmd(etat) {
      this.loadDmdParEtat(etat);
    },

    filtrerStatusDmd(status) {
      this.loadDmdParStatus(status);
    },

    filtrerRetardDmd() {
      this.loadDmdParRetard();
    },

    filtrerZoneDmd(idZone) {
      this.loadDmdParZone(idZone);
    },

    loadDmdParZone(idZone) {
      //this.loading = true;
      this.legendeTab = "LISTE DES DEMANDES DE MAINTENANCES FILTRE PAR ZONE";
      this.listeDemandes = this.oldListDemandes;

      this.selectStatusDmd = null;
      this.selectRetardDmd = null;
      this.listeDemandes = this.listeDemandes.filter(function(item) {
        return item.idZone == idZone;
      });
    },

    loadDmdParEtat(etat) {
      //this.loading = true;
      this.legendeTab = "LISTE DES DEMANDES DE MAINTENANCES FILTRE PAR ETAT ";
      this.listeDemandes = this.oldListDemandes;
      this.selectZoneDmd = null;
      this.selectStatusDmd = null;
      this.selectRetardDmd = null;
      this.listeDemandes = this.listeDemandes.filter(function(item) {
        return item.etatDmd == etat;
      });
    },
    loadDmdParStatus(status) {
      this.listeDemandes = this.oldListDemandes;
      this.selectZoneDmd = null;
      this.selectEtatDmd = null;
      this.selectRetardDmd = null;
      this.legendeTab = "LISTE DES DEMANDES DE MAINTENANCES FILTRE PAR STATUS ";
      this.listeDemandes = this.listeDemandes.filter(function(item) {
        return item.statut == status;
      });
    },

    loadDmdParRetard() {
      this.listeDemandes = this.oldListDemandes;
      this.selectZoneDmd = null;
      this.selectEtatDmd = null;
      this.selectStatusDmd = null;
      this.legendeTab =
        "LISTE DES DEMANDES DE MAINTENANCES EN RETARD DE REALISATION ";

      this.listeDemandes = this.listeDemandes.filter(function(item) {
        let date1 = new Date(item.dateFormat);
        let dateNow = new Date();
        let diff = dateDiff(date1, dateNow);
        if (diff.day >= 1 && item.statut != 2) {
          //si la difference est superieur a 1jours la demande est en retard
          return true;
        } else {
          return false;
        }
      });
    },

    clearSelect() {
      this.listeDemandes = this.oldListDemandes;
      this.legendeTab = "LISTE DES DEMANDES DE MAINTENANCES ";
    },

    //statistique etat
    statDemandeGlobal() {
      let optionDemandeGlobal = {
        title: {
          text: "ETATS DES DEMANDES",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        series: [
          {
            name: "",
            type: "pie",
            selectedMode: "single",
            radius: [0, "30%"],

            label: {
              normal: {
                position: "inner"
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              //{value:this.statDemandeG.refuse, name:'Demandes Refusées'},
              //{value:this.statDemandeG.accepte, name:'Demandes Acceptées', selected:true},
            ]
          },
          {
            name: "",
            type: "pie",
            radius: ["40%", "55%"],
            label: {
              normal: {
                formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                backgroundColor: "#eee",
                borderColor: "#aaa",
                borderWidth: 1,
                borderRadius: 4,

                rich: {
                  a: {
                    color: "#999",
                    lineHeight: 22,
                    align: "center"
                  },

                  hr: {
                    borderColor: "#aaa",
                    width: "100%",
                    borderWidth: 0.5,
                    height: 0
                  },
                  b: {
                    fontSize: 16,
                    lineHeight: 33
                  },
                  per: {
                    color: "#eee",
                    backgroundColor: "#334455",
                    padding: [2, 4],
                    borderRadius: 2
                  }
                }
              }
            },
            data: [
              {
                value: this.statDemandeG.enCour,
                name: "Demandes en attente d'un technicien"
              },
              //{value:this.statDemandeG.enRetard, name:"Demandes en retard d'exécution"},
              {
                value: this.statDemandeG.enAttente,
                name: "En Attente de constat"
              },
              {
                value: this.statDemandeG.attenteValid,
                name: "En attente de validation"
              },
              { value: this.statDemandeG.termine, name: "Terminées" },
              { value: this.statDemandeG.refuse, name: "Refusées" },
              {
                value: this.statDemandeG.intervEnCours,
                name: "En cours d'intervention"
              }
            ]
          }
        ]
      };
      let geneChartDemandeGlobal = echarts.init(
        document.getElementById("demandeGblobal")
      );
      geneChartDemandeGlobal.setOption(optionDemandeGlobal);
    },

    //statistique etat
    statStatutDemande() {
      let optionDemandeGlobal = {
        title: {
          text: "STATUS DES DEMANDES",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        series: [
          {
            name: "",
            type: "pie",
            selectedMode: "single",
            radius: [0, "30%"],

            label: {
              normal: {
                position: "inner"
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              //{value:this.statDemandeG.refuse, name:'Demandes Refusées'},
              //{value:this.statDemandeG.accepte, name:'Demandes Acceptées', selected:true},
            ]
          },
          {
            name: "",
            type: "pie",
            radius: ["40%", "55%"],
            label: {
              normal: {
                formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                backgroundColor: "#eee",
                borderColor: "#aaa",
                borderWidth: 1,
                borderRadius: 4,

                rich: {
                  a: {
                    color: "#999",
                    lineHeight: 22,
                    align: "center"
                  },

                  hr: {
                    borderColor: "#aaa",
                    width: "100%",
                    borderWidth: 0.5,
                    height: 0
                  },
                  b: {
                    fontSize: 16,
                    lineHeight: 33
                  },
                  per: {
                    color: "#eee",
                    backgroundColor: "#334455",
                    padding: [2, 4],
                    borderRadius: 2
                  }
                }
              }
            },
            data: [
              { value: this.statusDemande.attente, name: "En attente" },
              {
                value: this.statusDemande.enCours,
                name: "En cours de traitement"
              },
              { value: this.statusDemande.traite, name: "Traitée" }
            ]
          }
        ]
      };
      let geneChartDemandeGlobal = echarts.init(
        document.getElementById("statusGbDemande")
      );
      geneChartDemandeGlobal.setOption(optionDemandeGlobal);
    },

    //histogramme
    statDemandeAnnee() {
      var optionDemandeAnnee = {
        title: {
          text: "DEMANDES TRAITE ET NON TRAITE DURANT LES 12 DERNIERS MOIS"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },

        xAxis: [
          {
            type: "category",
            data: []
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "Demandes réfusés",
            type: "bar",
            data: []
          },
          {
            name: "Demandes en cours",
            type: "bar",
            data: []
          },
          {
            name: "Demandes traité",
            type: "bar",
            data: []
          }
        ]
      };

      this.demandeAnnee.forEach(function(element) {
        optionDemandeAnnee.xAxis[0].data.push(element.date);
        optionDemandeAnnee.series[0].data.push(element.refuse);
        optionDemandeAnnee.series[1].data.push(element.nonTraite);
        optionDemandeAnnee.series[2].data.push(element.traite);

        // optionDemandeAnnee.series[0].data.push(element.traite)
        // optionDemandeAnnee.series[1].data.push(element.nonTraite)
        // optionDemandeAnnee.series[2].data.push(element.refuse)
      });

      let maintChart = echarts.init(document.getElementById("demandeTraite"));
      maintChart.setOption(optionDemandeAnnee);
    },
    imprimeDemandePDF() {
      let tab = [];
      this.listeDemandes.forEach(function(demande) {
        tab.push(demande.idDemande);
      });

      let url = this.domaine + "demande_maintenance/imprimerPDF/liste/" + tab;
      window.open(url);
    },
    loadLieu() {
      let url = this.domaine + "demande_maintenance/lieu/" + this.user.id;

      this.$http.get(url).then(
        response => {
          this.comboZoneDmd = response.body.lieux;
        },
        erreurRep => {}
      );
    },
    //method tree zone
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick() {
      //c'est ici qu'on attribu le proprietés concernant la zone
      this.dataZone = this.$refs.tree.getCurrentNode();
      //this.filtrerZoneDmd(this.dataZone.id )
      this.dialogZoneEdit = true;
    }
  },
  mounted() {
    this.loadDemande();
    this.loadInfoRepresentant();
    this.loadLieu();
    this.loadTechnicien();
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/maintenance/Maintenance_index.vue